import { UnderCover } from '../Components/UnderCover/UnderCover'
import { Marquee } from '../Components/Marquee/Marquee'
import { ProductsShowcase } from '../Components/ProductsShowcase/ProductsShowcase'
import { Menu } from '../Components/Menu/Menu'
import { Cover } from '../Components/Cover/Cover'
import { Footer } from '../Components/Footer/Footer'
import { OverFooter } from '../Components/OverFooter/OverFooter'
import { Articles } from '../Components/Articles/Articles'
import { SocialWall } from '../Components/SocialWall/SocialWall'
import { Video } from '../Components/Video/Video'
import { useLanguage } from '../TranslationsContext'

export function Content() {
  const currentLanguage = useLanguage()

  return (
    <div className={`language-${currentLanguage}`}>
      <Menu />
      <Cover />
      <UnderCover />
      <ProductsShowcase />
      <Marquee />
      <SocialWall />
      <Articles />
      <Video />
      <OverFooter />
      <Footer />
    </div>
  )
}
